import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import aboutEn from '@shared/locales/en/about.json'
import appBannerEn from '@shared/locales/en/app-banner.json'
import authEn from '@shared/locales/en/auth.json'
import blogEn from '@shared/locales/en/blog.json'
import cartEn from '@shared/locales/en/cart.json'
import commonEn from '@shared/locales/en/common.json'
import InfoDeliveryEn from '@shared/locales/en/delivery-info.json'
import errorsEn from '@shared/locales/en/errors.json'
import favoritesEn from '@shared/locales/en/favorites.json'
import infoEn from '@shared/locales/en/info.json'
import isAdultEn from '@shared/locales/en/is-adult.json'
import modalDeliveryEn from '@shared/locales/en/modal-delivery.json'
import monthEn from '@shared/locales/en/month.json'
import navigationEn from '@shared/locales/en/navigation.json'
import orderEn from '@shared/locales/en/order.json'
import InfoPaymentEn from '@shared/locales/en/payment-info.json'
import personalEn from '@shared/locales/en/personal.json'
import productEn from '@shared/locales/en/product.json'
import searchEn from '@shared/locales/en/search.json'
import seoEn from '@shared/locales/en/seo.json'
import sortEn from '@shared/locales/en/sort.json'
import userEn from '@shared/locales/en/user.json'
import validationEn from '@shared/locales/en/validation.json'
import aboutKk from '@shared/locales/kk/about.json'
import appBannerKk from '@shared/locales/kk/app-banner.json'
import authKk from '@shared/locales/kk/auth.json'
import blogKk from '@shared/locales/kk/blog.json'
import cartKk from '@shared/locales/kk/cart.json'
import commonKk from '@shared/locales/kk/common.json'
import InfoDeliveryKk from '@shared/locales/kk/delivery-info.json'
import errorsKk from '@shared/locales/kk/errors.json'
import favoritesKk from '@shared/locales/kk/favorites.json'
import infoKk from '@shared/locales/kk/info.json'
import isAdultKk from '@shared/locales/kk/is-adult.json'
import modalDeliveryKk from '@shared/locales/kk/modal-delivery.json'
import monthKk from '@shared/locales/kk/month.json'
import navigationKk from '@shared/locales/kk/navigation.json'
import orderKk from '@shared/locales/kk/order.json'
import InfoPaymentKk from '@shared/locales/kk/payment-info.json'
import personalKk from '@shared/locales/kk/personal.json'
import productKk from '@shared/locales/kk/product.json'
import searchKk from '@shared/locales/kk/search.json'
import seoKk from '@shared/locales/kk/seo.json'
import sortKk from '@shared/locales/kk/sort.json'
import userKk from '@shared/locales/kk/user.json'
import validationKk from '@shared/locales/kk/validation.json'
import aboutRu from '@shared/locales/ru/about.json'
import appBannerRu from '@shared/locales/ru/app-banner.json'
import authRu from '@shared/locales/ru/auth.json'
import blogRu from '@shared/locales/ru/blog.json'
import cartRu from '@shared/locales/ru/cart.json'
import commonRu from '@shared/locales/ru/common.json'
import InfoDeliveryRu from '@shared/locales/ru/delivery-info.json'
import errorsRu from '@shared/locales/ru/errors.json'
import favoritesRu from '@shared/locales/ru/favorites.json'
import infoRu from '@shared/locales/ru/info.json'
import isAdultRu from '@shared/locales/ru/is-adult.json'
import modalDeliveryRu from '@shared/locales/ru/modal-delivery.json'
import monthRu from '@shared/locales/ru/month.json'
import navigationRu from '@shared/locales/ru/navigation.json'
import orderRu from '@shared/locales/ru/order.json'
import InfoPaymentRu from '@shared/locales/ru/payment-info.json'
import personalRu from '@shared/locales/ru/personal.json'
import productRu from '@shared/locales/ru/product.json'
import searchRu from '@shared/locales/ru/search.json'
import seoRu from '@shared/locales/ru/seo.json'
import sortRu from '@shared/locales/ru/sort.json'
import userRu from '@shared/locales/ru/user.json'
import validationRu from '@shared/locales/ru/validation.json'

const customDetector = {
  name: 'customDetector',
  lookup () {
    return (navigator.language || 'kk').split('-')[0]
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector(customDetector)

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        seo: seoEn,
        product: productEn,
        navigation: navigationEn,
        appBanner: appBannerEn,
        blog: blogEn,
        user: userEn,
        auth: authEn,
        validation: validationEn,
        sort: sortEn,
        modalDelivery: modalDeliveryEn,
        isAdult: isAdultEn,
        personal: personalEn,
        month: monthEn,
        cart: cartEn,
        order: orderEn,
        favorites: favoritesEn,
        InfoPayment: InfoPaymentEn,
        InfoDelivery: InfoDeliveryEn,
        about: aboutEn,
        info: infoEn,
        search: searchEn,
        errors: errorsEn,
      },
      ru: {
        common: commonRu,
        seo: seoRu,
        product: productRu,
        navigation: navigationRu,
        appBanner: appBannerRu,
        blog: blogRu,
        user: userRu,
        auth: authRu,
        validation: validationRu,
        sort: sortRu,
        modalDelivery: modalDeliveryRu,
        isAdult: isAdultRu,
        personal: personalRu,
        month: monthRu,
        cart: cartRu,
        order: orderRu,
        favorites: favoritesRu,
        InfoPayment: InfoPaymentRu,
        InfoDelivery: InfoDeliveryRu,
        about: aboutRu,
        info: infoRu,
        search: searchRu,
        errors: errorsRu,
      },
      kk: {
        common: commonKk,
        seo: seoKk,
        product: productKk,
        navigation: navigationKk,
        appBanner: appBannerKk,
        blog: blogKk,
        user: userKk,
        auth: authKk,
        validation: validationKk,
        sort: sortKk,
        modalDelivery: modalDeliveryKk,
        isAdult: isAdultKk,
        personal: personalKk,
        month: monthKk,
        cart: cartKk,
        order: orderKk,
        favorites: favoritesKk,
        InfoPayment: InfoPaymentKk,
        InfoDelivery: InfoDeliveryKk,
        about: aboutKk,
        info: infoKk,
        search: searchKk,
        errors: errorsKk,
      },
    },
    fallbackLng: 'kk',
    supportedLngs: [ 'en', 'ru', 'kk' ],
    load: 'languageOnly',
    detection: {
      order: [ 'localStorage', 'customDetector' ],
      lookupLocalStorage: 'i18nextLng',
      caches: [ 'localStorage' ],
    },
    interpolation: { escapeValue: false },
  })

export default i18n
